import { __awaiter, __generator } from "tslib";
import { gqlPluckFromCodeString, gqlPluckFromCodeStringSync, } from '@graphql-tools/graphql-tag-pluck';
import { loadFromGit, loadFromGitSync } from './load-git';
import { parse } from './parse';
// git:branch:path/to/file
function extractData(pointer) {
    var parts = pointer.replace(/^git\:/i, '').split(':');
    if (!parts || parts.length !== 2) {
        throw new Error('Schema pointer should match "git:branchName:path/to/file"');
    }
    return {
        ref: parts[0],
        path: parts[1],
    };
}
/**
 * This loader loads a file from git.
 *
 * ```js
 * const typeDefs = await loadTypedefs('git:someBranch:some/path/to/file.js', {
 *   loaders: [new GitLoader()],
 * })
 * ```
 */
var GitLoader = /** @class */ (function () {
    function GitLoader() {
    }
    GitLoader.prototype.loaderId = function () {
        return 'git-loader';
    };
    GitLoader.prototype.canLoad = function (pointer) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.canLoadSync(pointer)];
            });
        });
    };
    GitLoader.prototype.canLoadSync = function (pointer) {
        return typeof pointer === 'string' && pointer.toLowerCase().startsWith('git:');
    };
    GitLoader.prototype.load = function (pointer, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ref, path, content, parsed, rawSDL;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = extractData(pointer), ref = _a.ref, path = _a.path;
                        return [4 /*yield*/, loadFromGit({ ref: ref, path: path })];
                    case 1:
                        content = _b.sent();
                        parsed = parse({ path: path, options: options, pointer: pointer, content: content });
                        if (parsed) {
                            return [2 /*return*/, parsed];
                        }
                        return [4 /*yield*/, gqlPluckFromCodeString(pointer, content, options.pluckConfig)];
                    case 2:
                        rawSDL = _b.sent();
                        return [2 /*return*/, {
                                location: pointer,
                                rawSDL: rawSDL,
                            }];
                }
            });
        });
    };
    GitLoader.prototype.loadSync = function (pointer, options) {
        var _a = extractData(pointer), ref = _a.ref, path = _a.path;
        var content = loadFromGitSync({ ref: ref, path: path });
        var parsed = parse({ path: path, options: options, pointer: pointer, content: content });
        if (parsed) {
            return parsed;
        }
        var rawSDL = gqlPluckFromCodeStringSync(pointer, content, options.pluckConfig);
        return {
            location: pointer,
            rawSDL: rawSDL,
        };
    };
    return GitLoader;
}());
export { GitLoader };
//# sourceMappingURL=index.js.map